import { Outlet } from 'react-router';
import { Fragment } from 'react/jsx-runtime';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Separator,
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from '@virtual-care/shadcn';
import { ThemeProvider } from '@virtual-care/ui';

import { CommandPalette } from './components/command-palette';
import { useBreadcrumbs } from './hooks/use-breadcrumbs';
import { AppSidebar } from './navigation/app-sidebar';

function MainSidebar() {
  const breadcrumbs = useBreadcrumbs();
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="flex h-16 shrink-0 items-center gap-2">
          <div className="flex w-full items-center gap-2 px-4">
            <SidebarTrigger className="-ml-1" />
            <Separator orientation="vertical" className="mr-2 h-4" />
            <Breadcrumb>
              <BreadcrumbList>
                {breadcrumbs.map((crumb, index) => (
                  <Fragment key={crumb.path || `crumb-${index}`}>
                    <BreadcrumbItem>
                      {crumb.isLast || !crumb.path ? (
                        <BreadcrumbPage>{crumb.title}</BreadcrumbPage>
                      ) : (
                        <BreadcrumbLink href={crumb.path}>
                          {crumb.title}
                        </BreadcrumbLink>
                      )}
                    </BreadcrumbItem>
                    {!crumb.isLast && <BreadcrumbSeparator />}
                  </Fragment>
                ))}
              </BreadcrumbList>
            </Breadcrumb>
          </div>
        </header>

        <div className="flex flex-1 flex-col gap-4 p-4 pt-0">
          <Outlet />
        </div>

        <CommandPalette />
      </SidebarInset>
    </SidebarProvider>
  );
}

export default function Layout() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="ui-theme">
      <MainSidebar />
    </ThemeProvider>
  );
}
